import React, { ReactElement } from 'react';
import OnboardingPage from 'src/routes/OnboardingPage';
import OnboardingAppLayout from './layouts/OnboardingAppLayout';

function OnboardingRoute(): ReactElement {
	return (
		<OnboardingAppLayout noSubHeader={true}>
			<OnboardingPage />
		</OnboardingAppLayout>
	);
}

export default OnboardingRoute;
